module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-list"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('input', {
    staticClass: "search",
    attrs: {
      "placeholder": "Search Chats..."
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "link-simple",
    attrs: {
      "to": "/chats/new"
    }
  }, [_vm._v("New")])], 1), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.chats), function(chat, id) {
    return _c('item', {
      key: chat['.key'],
      attrs: {
        "after": chat.showAfter,
        "id": chat['.key']
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34f03d38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/list/List.vue
// module id = 702
// module chunks = 1